import React from 'react';
import Map from '@/pages/opinion/components/MapCommon';
import { transRegion } from '@/pages/opinion/utils';
import { sentimentColorMap } from '@/pages/opinion/constants';
import {
  region,
  regionType,
  regionData,
} from '@/pages/opinion/components/MapCommon/type';
import { cloneDeep } from 'lodash-es';
import { useIntl, getLocale } from 'umi';
import { overviewMapTips } from '@/pages/opinion/components/BubbleCommon';

export default function RegionsMap({
  regionType = 'region',
  data = [],
}: {
  regionType: regionType;
  data: any[];
}) {
  const { formatMessage } = useIntl();

  const localeData = cloneDeep(data);

  const regionData: regionData = cloneDeep(
    sentimentColorMap.map((item) => ({
      ...item,
      sentimentType: formatMessage({ id: item.sentimentType }),
    })),
  );

  let mentionsMax = 0;
  let mentionsTotal = 0;

  const handleData = (type: string, dataItem: region) => {
    const positive = regionData.find((item) => item.sentimentType === type);
    if (positive && !positive.data) positive.data = [];
    positive && positive.data?.push({ ...dataItem });
  };

  let unidentifiedMentions = 0;

  if (localeData?.length > 0) {
    localeData.forEach((item) => {
      if (!item) return;

      if (item.name.toLocaleLowerCase() === 'unidentified') {
        unidentifiedMentions = item.count;
      } else {
        mentionsMax = Math.max(item.count, mentionsMax);
      }

      mentionsTotal += item?.count; // 记录mentions总数量
      item.value = item?.count; // 散点图value

      if (getLocale() === 'zh-CN') {
        item.name = transRegion(item.name, regionType === 'region' ? 5 : 4);
      }

      if (getLocale() === 'en-US') {
        item.name = transRegion(item.name, regionType === 'region' ? 1 : 2);
      }

      if (item.avg_sentiment > 3.5) {
        handleData(formatMessage({ id: 'Positive' }), item);
      } else if (item.avg_sentiment >= 2.5) {
        handleData(formatMessage({ id: 'Neutral' }), item);
      } else {
        handleData(formatMessage({ id: 'Negative' }), item);
      }
    });
  }

  // console.log('mapmap', regionData);

  return (
    <Map
      data={regionData}
      total={mentionsTotal}
      max={mentionsMax}
      bubbleTips={overviewMapTips}
      regionType={regionType}
      unidentifiedMentions={unidentifiedMentions}
    />
  );
}
